// Scripting for sliders or carousels (Fairtrade theme includes a slider block that uses slick slider)
(function($){
	// New Baytek Block
	$('.carousel-slider-no-text').each(function () {
		var slickIndividual = $(this);
		slickIndividual.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			// arrows: true,
			dots: true,
			variableWidth: false,
			autoplay: true,
			autoplaySpeed: 5000,
			prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fal fa-long-arrow-left"></i></button>',
			nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fal fa-long-arrow-right"></i></button>',
			responsive: [
				{
					breakpoint: 720,
					settings: {
						arrows: false,
					}
				}
			]
		});
	});

	// ////////////////////////
	//brand slider and tabs
	//////////////////////////
	$('.carousel-brand-slider').each(function () {
		var slickIndividual = $(this);
		slickIndividual.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: false,
			fade: true,
			prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fal fa-long-arrow-left"></i></button>',
			nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fal fa-long-arrow-right"></i></button>'
		});
	});
	$('.carousel-brand-tabs').each(function () {
		var slickIndividual = $(this);
		slickIndividual.slick({
			slidesToShow: 6,
			slidesToScroll: 1,
			variableWidth: false,
			asNavFor: '.carousel-brand-slider',
			focusOnSelect: false,
			focusOnChange: true,
			accessibility: true
		});
	});
	$('.carousel-brand-tabs .slick-slide').on('click', function (event) {
		$('.carousel-brand-slider').slick('slickGoTo', $(this).data('slickIndex'));
		activeClass($('.carousel-brand-slider .slick-active').data('slickIndex'));
	});
	$('.carousel-brand-slider').on('click', function (event) {
		activeClass($('.carousel-brand-slider .slick-active').data('slickIndex'));
	});
	// add/remove the .active on tabs
	function activeClass(slideIndex) {
		$('.carousel-brand-tabs .card').removeClass('slick-current');
		$('.carousel-brand-tabs .card[data-slick-index=' + slideIndex + ']').addClass('slick-current');
	}
	//////////////////////////

	$('.infographic-wrapper').slick({
		arrows: true,
		dots: false,
		variableWidth: true,
		slidesToScroll: 1,
		infinite: false,
		draggable: true,
		prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fal fa-long-arrow-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fal fa-long-arrow-right"></i></button>'
	});

	$('.news-wrapper .wp-block-group__inner-container').slick({
		arrows: true,
		dots: false,
		variableWidth: true,
		slidesToScroll: 1,
		infinite: true,
		draggable: true,
		prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fal fa-long-arrow-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fal fa-long-arrow-right"></i></button>',
	});
	$('.blog-wrapper .wp-block-group__inner-container').slick({
		arrows: true,
		dots: false,
		variableWidth: true,
		slidesToScroll: 1,
		infinite: true,
		draggable: true,
		prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fal fa-long-arrow-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fal fa-long-arrow-right"></i></button>'
	});
	$('.wp-block-group.is-style-slider .wp-block-group__inner-container').slick({
		arrows: true,
		dots: false,
		variableWidth: false,
		slidesToScroll: 1,
		infinite: true,
		draggable: true,
		prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fal fa-long-arrow-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fal fa-long-arrow-right"></i></button>',
		responsive: [
			{
				breakpoint: 720,
				settings: {
					arrows: false,
				}
			}
		]
	});
})(jQuery);
